import { render, staticRenderFns } from "./im-custom-register.vue?vue&type=template&id=755d5292&scoped=true"
import script from "./im-custom-register.vue?vue&type=script&lang=js"
export * from "./im-custom-register.vue?vue&type=script&lang=js"
import style0 from "./im-custom-register.vue?vue&type=style&index=0&id=755d5292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d5292",
  null
  
)

export default component.exports